import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const showConfirmation = ({ title, message, onConfirm, onReject }) => {
    confirmAlert({
        title,
        message,
        buttons: [
            {
                label: 'Da',
                onClick: () => onConfirm(),
                className: 'dialog-button',
            },
            {
                label: 'Odustani',
                onClick: () => (onReject ? onReject() : null),
            },
        ],
    });
};

export default showConfirmation;